import RestaurantSource from '../../data/restaurant-source'
import UrlParser from '../../routes/url-parser'
import { restaurantDetailTemplate } from '../templates/template-creator'
import FavoriteButtonPresenter from '../../utils/favorite-button-presenter'
import AccordionInitiator from '../../utils/accordion-initiator'
import ModalInitiator from '../../utils/modal-initiator'

const Detail = {
  async render () {
    return `
      <div id="restaurant" class="restaurant"></div>
    `
  },

  async afterRender () {
    const test = document.querySelector('.test')
    test.style.height = 0

    const url = UrlParser.parseActiveUrlWithoutCombiner()
    const restaurant = await RestaurantSource.detailRestaurant(url.id)

    const loader = document.querySelector('.backdrop')
    loader.style.display = 'none'

    const restaurantContainer = document.querySelector('#restaurant')
    restaurantContainer.innerHTML = restaurantDetailTemplate(restaurant)

    FavoriteButtonPresenter.init({
      favoriteButtonContainer: document.querySelector('#favorite'),
      restaurant: {
        id: restaurant.id,
        name: restaurant.name,
        pictureId: restaurant.pictureId,
        city: restaurant.city,
        rating: restaurant.rating
      }
    })

    AccordionInitiator.init({
      accordionButtonContainer: document.querySelector('.accordion')
    })

    ModalInitiator.init({
      modal: document.querySelector('.modal'),
      showModalButton: document.querySelector('.show'),
      hideModalButton: document.querySelector('.hide'),
      id: restaurant.id
    })
  }
}

export default Detail
